import * as React from 'react';
import clsx from 'clsx';
import { Link as RouterLink, LinkProps as RouterLinkProps, useLocation } from 'react-router-dom';
import MuiLink, { LinkProps as MuiLinkProps } from '@mui/material/Link';
import { styled } from '@mui/material/styles';

// Add support for the sx prop for consistency with the other branches.
const Anchor = styled('a')({});

export type LinkProps = {
  activeClassName?: string;
  href: string;
  noLinkStyle?: boolean;
} & Omit<RouterLinkProps, 'to'> &
  Omit<MuiLinkProps, 'href'>;

// A styled version of the React Router Link component
const Link = React.forwardRef<HTMLAnchorElement, LinkProps>(function Link(props, ref) {
  const {
    activeClassName = 'active',
    className: classNameProps,
    href,
    noLinkStyle,
    role,
    ...other
  } = props;

  const location = useLocation();
  const pathname = location.pathname;
  const className = clsx(classNameProps, {
    [activeClassName]: pathname === href && activeClassName,
  });

  const isExternal =
    typeof href === 'string' && (href.indexOf('http') === 0 || href.indexOf('mailto:') === 0);

  if (isExternal) {
    if (noLinkStyle) {
      return <Anchor className={className} href={href} ref={ref} {...other} />;
    }

    return <MuiLink className={className} href={href} ref={ref} {...other} />;
  }

  if (noLinkStyle) {
    return <RouterLink className={className} to={href} ref={ref as any} {...other} />;
  }

  return <MuiLink component={RouterLink} className={className} to={href} ref={ref} {...other} />;
});

export default Link;
